export class RoleMenuFlatModel {
	public id: string;
	public channel: string;
	public name: string;
	public parentId: string;
	public target: string;
	public level: number;
	public expandable: boolean;
}
